// extracted by mini-css-extract-plugin
export default {"btn":"ScrollTopBtn_btn__Ea0Ap","dark":"ScrollTopBtn_dark__cBP-7","active":"ScrollTopBtn_active__D7Z6L"};